import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import { SingleDatePicker } from 'react-dates'
import RegionCompanySelect from 'component/branch/RegionCompanySelect'

class AnalyticsFilterForm extends Component {
  state = {
    dtStartFocused: false,
    dtEndFocused: false,
    selectedBranches: [],
  }

  isOutsideRange = () => false

  handleSubmit = (event) => {
    event.preventDefault()

    const { values, handleFilters } = this.props

    const { selectedBranches } = this.state

    const idBranches = selectedBranches
      .filter((item) => item.isBranch !== undefined)
      .map((item) => item.value)
    const idRegions = selectedBranches
      .filter((item) => item.isBranch === undefined)
      .map((item) => item.value)

    const filters = {
      ...values,
      dtInicio: values.dtStart
        ? moment(values.dtStart).format('DD/MM/YYYY')
        : null,
      dtFim: values.dtEnd ? moment(values.dtEnd).format('DD/MM/YYYY') : null,
      idBranches,
      idRegions,
    }

    handleFilters(filters)
  }

  handleChangeBranch = (values, allOptions) => {
    const allValues = []

    allOptions.map((newItem) => {
      newItem.visible = true
      newItem.disabled = false
    })

    if (!!values && values.length > 0) {
      const regionsSelected = values.filter(
        (item) => item.isBranch === undefined
      )

      values.map((item) => {
        if (!item.isBranch) {
          allOptions
            .filter((branchItem) => branchItem.idRegion === item.value)
            .map((newItem) => {
              newItem.visible = false
              newItem.disabled = true
            })
          allValues.push(item)
        } else {
          if (
            regionsSelected.filter(
              (regionItem) => regionItem.value === item.idRegion
            ).length === 0
          ) {
            allValues.push(item)
          }
        }
      })
    }
    this.setState({ selectedBranches: allValues })
  }

  clearFields = () => {
    const { fields, setValueToField } = this.props

    Object.keys(fields).forEach((field) => {
      setValueToField(field, '')
    })
  }

  render() {
    const { translate, fields, setValueToField } = this.props

    const { dtStartFocused, dtEndFocused } = this.state

    return (
      <form className='MenuAnalyticsFilterForm'>
        <fieldset>
          <Row>
            <Col xs={12}>
              <legend>{translate('analytics.filter-accesses')}</legend>
            </Col>
          </Row>

          <Row className='margin-top-double'>
            <Col xs={12} md={12}>
              <Field
                {...fields.idBranch}
                error={translate(fields.idBranch.error)}
              >
                <RegionCompanySelect
                  {...fields.idBranch.input}
                  onChange={this.handleChangeBranch}
                  selectedBranches={this.state.selectedBranches}
                  showInternalServices
                  isDisabled={false}
                  labelAll={translate('analytics.allBranches')}
                />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={6}>
              <div className='field'>
                <Field
                  {...fields.dtStart}
                  error={translate(fields.dtStart.error)}
                  glyph='glyph glyph-calendar'
                >
                  <SingleDatePicker
                    date={fields.dtStart.input.value || null}
                    onDateChange={(date) => setValueToField('dtStart', date)}
                    focused={dtStartFocused}
                    onFocusChange={({ focused }) =>
                      this.setState({ dtStartFocused: focused })
                    }
                    placeholder={translate('suggestion.startDate')}
                    numberOfMonths={1}
                    displayFormat='DD/MM/YYYY'
                    isOutsideRange={this.isOutsideRange}
                  />
                </Field>
              </div>
            </Col>
            <Col xs={6} md={6}>
              <div className='field'>
                <Field
                  {...fields.dtEnd}
                  error={translate(fields.dtEnd.error)}
                  glyph='glyph glyph-calendar'
                >
                  <SingleDatePicker
                    date={fields.dtEnd.input.value || null}
                    onDateChange={(date) => setValueToField('dtEnd', date)}
                    focused={dtEndFocused}
                    onFocusChange={({ focused }) =>
                      this.setState({ dtEndFocused: focused })
                    }
                    placeholder={translate('suggestion.endDate')}
                    numberOfMonths={1}
                    displayFormat='DD/MM/YYYY'
                    isOutsideRange={this.isOutsideRange}
                  />
                </Field>
              </div>
            </Col>
          </Row>
        </fieldset>

        <Row className='margin-top-double margin-bottom'>
          <Col xs={12} md={12}>
            <button
              role='button'
              type='button'
              onClick={this.handleSubmit}
              className='button button-primary button-full'
            >
              {translate('filter_button_label')}
            </button>
          </Col>
        </Row>
      </form>
    )
  }
}

AnalyticsFilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleFilters: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
}

const fields = ['idBranch', 'dtStart', 'dtEnd']

export default Form({ fields })(AnalyticsFilterForm)

export { AnalyticsFilterForm }
